<template>
  <header class="app-header navbar">
    <div class="navbar-left"></div>
    <div class="navbar-right">
      <div class="navbar-popover">
        <el-popover
          ref="popover1"
          placement="bottom"
          width="200"
          trigger="hover"
        >
          <div class="group-popover">
            <p class="group-popover-title">实时反馈/获取优化进度</p>
            <img
              class="group-popover-img"
              width="176"
              src="https://mktv-in-cdn.mockuai.com/16355156887453846.png"
              alt=""
            />
            <span class="group-popover-info" data-id="11.05">企业微信扫码进群</span>
          </div>
        </el-popover>
        <span v-popover:popover1>YYTools使用者群</span> 
        |
        <span :data-track="
          JSON.stringify({
            t: '0004', 
          })
        "><a href="https://yydocs.mockuai.net/tools/page.html" target="_black">YYtools使用文档</a></span>
      </div>
      <div class="content">
        <b-nav is-nav-bar class="ml-auto">
          <b-nav-item-dropdown right>
            <template slot="button-content">
              <span>当前登录: {{ userName }}</span>
            </template>
            <b-dropdown-item @click="logout">
              <i class="icon-logout"></i> 退出登录
            </b-dropdown-item>
            <b-dropdown-item @click="modifyPassWord">
              <i class="icon-like"></i> 修改密码
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-nav>
      </div>
    </div>
  </header>
</template>
<style lang="scss" scoped>
.app-header{
  border: none;
}
/deep/.dropdown-toggle:hover {
    background: transparent !important;
}
.notice-content {
  height: 330px;
  display: flex;
  flex-direction: column;
  .notice-title {
    line-height: 40px;
    height: 40px;
    text-align: center;
    border-bottom: 1px solid #f0f0f0;
  }
  .content-main {
    height: 230px;
    overflow-y: scroll;
    width: 100%;
    padding-bottom: 10px;
    padding-right: 10px;
    .notice-cell {
      display: flex;
      align-items: center;
      width: 100%;
      border-bottom: 1px solid #f0f0f0;
      padding-bottom: 10px;
      padding-top: 10px;
      .notice-unread {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .unread {
          width: 8px;
          height: 8px;
          border-radius: 100%;
          background: #ff4b55;
        }
      }
      .notice-main {
        flex: 1;
        margin-left: 10px;
        display: flex;
        min-height: 50px;
        flex-direction: column;
        justify-content: space-between;
        .notice-header {
          display: flex;
          align-items: center;
          width: 100%;
          justify-content: space-between;
        }
        .notice-content-main {
          width: 100%;
          margin-top: 10px;
          .notice-span {
            color: #4a8ef7;
            cursor: pointer;
          }
        }
      }
    }
  }
  .content-but {
    margin-top: 10px;
    display: flex;
    align-items: center;
    flex: 1;
    flex-direction: row-reverse;
    padding-right: 20px;
  }
}
.navbar-right {
  display: flex;
  align-items: center;
  .navbar-popover {
    flex: 1;
    align-items: center;
    justify-content: flex-end;
    text-align: right;
    padding-right: 36px;
    color: #eeeeee;
    span {
      color: #4a8ef7;
      font-weight: bold;
    }
  }

  .content {
    display: flex;
    align-items: center;
    color: #536c79;
    height: 45px;
    box-sizing: inherit;
    line-height: 45px;
    cursor: pointer;
    .unread-icon {
      width: 20px;
      height: 20px;
      margin-right: 5px;
      background: url("https://img.mockuai.com/tms/2018/9/6/upload_1edd9b364af54a49f5533b45801ff67c.png");
      background-size: 100% 100%;
    }
    .content-unread {
      width: 8px;
      height: 8px;
      border-radius: 100%;
      background: #ff4b55;
      margin-left: 5px;
      position: relative;
      top: -5px;
    }
    .but {
      line-height: 45px;
      margin-left: 10px;
      margin-right: 50px;
    }
  }
}
.group-popover {
  text-align: center;
  .group-popover-title {
    font-size: 14px;
    color: #333;
    font-weight: bold;
  }
  .group-popover-img {
    display: block;
    padding: 10px 20px 0;
  }
  .group-popover-info {
    font-size: 12px;
    color: #666;
  }
}
</style>
<script>
import { debounce } from "@/js/debounce.js";
export default {
  name: "header",
  props: ["logo_url"],
  data() {
    return {
      userName: null,
      industry_name: null,
      visible: false,
      message_notification_list: [],
      time_interval: 30000,
      unreadCount: 0,
      timer: "",
    };
  },
  mounted() {
    this.userName = lib.storage.get('user') ? lib.storage.get('user').nickname : "未知";

    this.initCollapse();
    window.onresize = debounce(() => {
      this.initCollapse();
    }, 350);
  },
  methods: {
    initCollapse() {
      // 根据浏览器大小改变侧边栏
      const documentWidth =
        document.documentElement.clientWidth || document.body.clientWidth;
      let index = [...document.body.classList].indexOf("sidebar-hidden");
      if (index === -1 && documentWidth < 1200) {
        // 如果侧边栏已收缩了 则不做什么。
        document.body.classList.add("sidebar-hidden");
      } else if (index !== 1 && documentWidth >= 1200) {
        document.body.classList.remove("sidebar-hidden");
      }
    },
    modifyPassWord() {
      this.$router.push({ path: "/pages/modifypasswd" });
    },
    sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-hidden");
    },
    sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-minimized");
    },
    mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-mobile-show");
    },
    asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("aside-menu-hidden");
    },
    logout() {
      lib.cookie.rm("yytools_token");
      this.$router.push({ path: "/pages/login" });
    },
    clickPopover() {
      let that = this;
      that.getMessageList();
    },
  },
};
</script>
